import { OnboardingRootState } from "../reducers/rootReducer";
import { initialPitchPageState, PitchPageState } from "../reducers/pitchPageReducer";
import { getOnboardingState } from "./rootSelectors";

export const getPitchPageState = (state: OnboardingRootState): PitchPageState =>
  getOnboardingState(state)?.pitchPage ?? initialPitchPageState;

export const getPitchPageData = (state: OnboardingRootState) => getPitchPageState(state).data;

export const getPitchPageIsLoading = (state: OnboardingRootState) =>
  getPitchPageState(state).isLoading;

export const getPitchPageIsSaving = (state: OnboardingRootState) =>
  getPitchPageState(state).isSaving;

export const getPitchPageIsSubmitting = (state: OnboardingRootState) =>
  getPitchPageState(state).isSubmitting;

export const getPitchPageError = (state: OnboardingRootState) => getPitchPageState(state).error;

export const getPitchPageIsDraft = (state: OnboardingRootState) =>
  getPitchPageState(state).data?.isDraft ?? true;
